import React from 'react';
import { useParams } from 'react-router-dom';
import EmptyState from '../../components/common/EmptyState/EmptyState';
import Commercial from '../Commercial/Commercial';

const MarketingProjectLeads: React.FC = () => {
  const { projectCode } = useParams<{ projectCode: string }>();
  const lockedProjectCode = projectCode ? decodeURIComponent(projectCode).trim() : '';

  if (!lockedProjectCode) {
    return <EmptyState message="Projeto não encontrado." />;
  }

  return <Commercial lockedProjectCode={lockedProjectCode} />;
};

export default MarketingProjectLeads;
